import { FC } from 'react';
import { Box, BoxProps, Flex, Skeleton, Stack } from '@chakra-ui/react';
export interface CbStarEntitySkeletonProps extends BoxProps {}
export const CbStarEntitySkeleton: FC<CbStarEntitySkeletonProps> = ({
  ...props
}) => {
  return <>
      <Flex alignItems="flex-start" {...props} data-sentry-element="Flex" data-sentry-source-file="CbStarEntitySkeleton.tsx">
        <Skeleton borderRadius={100} width={16} height={16} data-sentry-element="Skeleton" data-sentry-source-file="CbStarEntitySkeleton.tsx" />
        <Box marginLeft={2} data-sentry-element="Box" data-sentry-source-file="CbStarEntitySkeleton.tsx">
          <Stack data-sentry-element="Stack" data-sentry-source-file="CbStarEntitySkeleton.tsx">
            <Skeleton width="100px" height="20px" data-sentry-element="Skeleton" data-sentry-source-file="CbStarEntitySkeleton.tsx" />
            <Skeleton width={{
            base: '2xs',
            md: 'sm'
          }} height="15px" data-sentry-element="Skeleton" data-sentry-source-file="CbStarEntitySkeleton.tsx" />
            <Skeleton width={{
            base: '2xs',
            md: 'sm'
          }} height="15px" data-sentry-element="Skeleton" data-sentry-source-file="CbStarEntitySkeleton.tsx" />
          </Stack>
        </Box>
      </Flex>
    </>;
};